import { HttpErrorResponse } from '@angular/common/http';

/** Business error: a line or afroep would use more than the contract has left. */
export const CONTRACT_OVER_ALLOCATION = '@Contract.OverAllocation';

export interface ContractOverAllocation {
  remaining: number;
  /** 'trucks' on a truck contract, otherwise the contract's quantity unit ('ton'). */
  unit: string;
}

/** The remaining amount the server reported when it refused an over-allocation, or null for any other error. */
export function readOverAllocation(error: unknown): ContractOverAllocation | null {
  if (!(error instanceof HttpErrorResponse) || error.error?.code !== CONTRACT_OVER_ALLOCATION) {
    return null;
  }

  const data = (error.error.data ?? {}) as Record<string, string>;
  const remaining = Number(data['Remaining']);
  return { remaining: Number.isFinite(remaining) ? remaining : 0, unit: data['Unit'] || 'ton' };
}

/** "212 trucks" for trucks, otherwise the quantity with the article's precision: "4.433,70 ton". */
export function formatContractAmount(value: number, unit: string, precision = 2, locale = 'nl-BE'): string {
  const digits = unit === 'trucks' ? 0 : precision;
  const number = new Intl.NumberFormat(locale, { minimumFractionDigits: digits, maximumFractionDigits: digits }).format(
    value
  );
  return `${number} ${unit}`;
}
